import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem', background: '#fff8fb' }}>
      <section style={{ maxWidth: 520, textAlign: 'center' }}>
        <p style={{ textTransform: 'uppercase', letterSpacing: '0.24em', color: '#b11f72', fontWeight: 700 }}>404</p>
        <h1 style={{ margin: '0.5rem 0', fontSize: '2rem', color: '#1f1a1c' }}>Page not found</h1>
        <p style={{ marginBottom: '1.5rem', color: '#5b4c54' }}>
          The page you requested doesn’t exist or has moved.
        </p>
        <Link to="/" style={{ display: 'inline-block', padding: '0.9rem 1.25rem', background: '#c2187a', color: '#fff', textDecoration: 'none', borderRadius: 999 }}>
          Return to home
        </Link>
      </section>
    </main>
  );
}
